export const DSPCustomers = [
  'Spotify',
  'spotify',
  'Apple',
  'apple',
  'Shazam',
  'shazam',
  'KKBox',
  'kkbox',
  'Tencent',
  'tencent',
  'soundCloud',
  'Soundcloud',
  'Napster',
  'Tidal',
  'Netease',
  'netease',
  'Youtube',
  'youtube',
  'youTube',
  'YoutubeVideo',
  'youtubeVideo',
  'KuWo',
  'kuWo',
  'KuGou',
  'kuGou',
  'Pandora',
  'pandora',
  'GooglePlay',
  'googlePlay',
  'Amazon',
  'amazon',
  'Apple Music',
  'appleMusic',
  'AmazonUnlimited',
  'amazonUnlimited',
  'Deezer',
  'deezer',
  'Google Doc Charts',
  'QQ',
  'qq',
  'Yandex',
  'yandex',
  'iTunes',
  'itunes',
  'TDC',
  'tdc',
];
